import { Ref } from 'semantic-ui-react';
export default Ref;